import api from "../../services/api";
import { sendMediaOptimistic, sendTextOptimistic } from "../MessageInput/optimisticSend";
import { fileInfoFromUrl } from "./FileCard";

// "Tentar de novo" numa mensagem já gravada que não saiu: o mesmo conteúdo vai de novo, como
// mensagem nova. Em dois tempos — prepara (baixa o anexo) e devolve a função que envia — porque
// quem chama apaga a mensagem antiga entre um e outro, e apagar remove o arquivo do servidor.
export const resendMessage = async (message, ticketId) => {
  if (!message.mediaUrl) {
    return () => sendTextOptimistic({
      ticketId,
      payload: {
        read: 1,
        fromMe: true,
        mediaUrl: "",
        body: message.body,
        quotedMsg: message.quotedMsg || null,
        isPrivate: "false",
      },
    });
  }

  const { data: blob } = await api.get(message.mediaUrl, { responseType: "blob" });
  const { name } = fileInfoFromUrl(message.mediaUrl, "arquivo");
  // documento sem legenda guarda o nome do arquivo no corpo: não é legenda
  const caption = message.body && message.body !== name ? message.body : "";
  return () => sendMediaOptimistic({
    ticketId,
    isPrivate: false,
    items: [{ file: blob, fileName: name, caption }],
    buildFormData: (items) => {
      const formData = new FormData();
      formData.append("fromMe", true);
      formData.append("isPrivate", "false");
      items.forEach((item) => {
        formData.append("body", item.caption);
        formData.append("medias", item.file, item.fileName);
      });
      return formData;
    },
  });
};
